export interface Suggestion {
  id?: string;
  text: string;
  answered?: boolean;
}

export enum GzTextareaWithSuggestionsEvents {
  VIEW_ANSWER = 'viewAnswer',
  SELECT_SUGGESTION_FROM_LIST = 'selectSuggestionFromList',
  SEND_SUGGESTION = 'sendSuggestion',
  DEFAULT_SUGGESTION_SELECTED = 'defaultSuggestionSelected',
}
